import { render, staticRenderFns } from "./DonneesPersonnelles.vue?vue&type=template&id=67461f3e&%3Akey=componentKey&"
import script from "./DonneesPersonnelles.vue?vue&type=script&lang=js&"
export * from "./DonneesPersonnelles.vue?vue&type=script&lang=js&"
import style0 from "./DonneesPersonnelles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports